import * as yup from "yup";
import { validationSchemas } from "./data";

export const tableSchema = yup.object().shape({
  tableName: validationSchemas.name,
  amount: validationSchemas.numberInteger,
});
